import { format } from 'date-fns';

export const TRIGGER_ENGAGEMENT_CHART_OPTIONS = {
    colors: [
        '#733567',
        '#E9BEE3'
    ],
    lang: { noData: 'No data to display' },
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030'
        }
    },
    chart: {
        type: 'pie',
        backgroundColor: null,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false
    },
    title: { text: null },
    subtitle: { text: null },
    exporting: { enabled: false },
    credits: { enabled: false },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px'
        },
        formatter: function () {
            return `<b>${this.key}</b>: ${this.y}% <br>`;
        }
    },
    legend: {
        useHTML: true,
        layout: 'vertical',
        verticalAlign: 'bottom',
        itemStyle: {
            color: '#667085',
            fontWeight: 400,
            fontSize: '12px'
        },
        labelFormatter() {
            return `${this.options.name} ${this.options.y + '%'}`;
            return `<span>${this.options.name
            }</span> <span class="donut-chart-legend-value">${this.options.y + '%'
            }</span>`;
            // return `<div class="flex-row justify-space-between">
            //             <div class="donut-chart-legend-segment">${this.options.name}</div>
            //             <div class="donut-chart-legend-value">${this.options.y + '%'} </div>
            //         </div>`
        }
    },
    plotOptions: {
        pie: {
            shadow: false,
            borderWidth: 0,
            allowPointSelect: false,
            size: '100%',
            dataLabels: { enabled: false }
        }
    },
    series: [
        {
            name: 'Physician Engagement Segments',
            data: [
                {
                    name: 'Engaged',
                    y: 80
                },
                {
                    name: 'Not Engaged',
                    y: 20
                }
            ],
            size: '100%',
            innerSize: '50%',
            showInLegend: true,
            borderRadius: 0
        }
    ]
};

export const CREATIVE_NAME_CHART_SERIES = [{
    name: 'Trigger Count',
    data: [3.9, 3.7, 3.5, 3.8, 3.9, 4.3, 4.0]
}];

export const CREATIVE_NAME_CHART_OPTIONS = {
    chart: {
        id: 'creative-name',
        type: 'area',
        toolbar: {
            show: false,
            tools: {
                download: false,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false
            }
        }
    },
    noData: {
        text: 'No data available for Creative',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#333',
            fontSize: '18px'
        }
    },
    colors: ['#AD509E'],
    dataLabels: { enabled: false },
    markers: {
        size: 0,
        style: 'hollow'
    },
    xaxis: {
        type: 'datetime',
        title: {
            text: 'Month',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        tooltip: { enabled: false }
    },
    tooltip: { x: { format: 'dd MMM yyyy' } },
    stroke: { curve: 'smooth' },
    fill: {
        type: 'gradient',
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.3,
            opacityTo: 0.5,
            stops: [0, 100]
        }
    },
    yaxis: {
        title: {
            text: 'Count',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        labels: {
            formatter: function (val) {
                return val.toFixed(0);
            }
        },
        min: 0
    },
    legend: {
        show: false,
        position: 'top',
        horizontalAlign: 'center',
        showForSingleSeries: true
    },
    grid: { show: false }
};